'use client';
import React from 'react';
import moment from 'moment';
import { Controller } from 'react-hook-form';
import { Checkbox } from '@/components/customercenter-ui/ui/checkbox';
import { useMutuallyExclusiveDobSsn } from '@/components/customercenter-ui/utils/useMutuallyExclusiveDobSsn';
import { useCheckout } from '@/context/checkoutProvider';
import { mapLocaleToMeaningfulFormat } from '@/helpers/utils/i18n';
import UserInfo from './UserInfo';

const CreditInformation = ({ register, errors, setValue, control, data }: any) => {
  const { soaCustomer } = useCheckout();
  const customerDOB = soaCustomer?.CustomerInfo?.dob ?? '';
  const originalDob = customerDOB
    ? moment(customerDOB).isValid()
      ? moment(customerDOB).format('MM/DD/YYYY')
      : ''
    : '';
  const originalSsn = soaCustomer?.CustomerInfo?.ssn ?? '';

  const { disableDob, disableSsn } = useMutuallyExclusiveDobSsn({
    control,
    dobName: 'dpqDOB',
    ssnName: 'ssn',
    originalDob,
    originalSsn,
    isActive: true,
  });

  return (
    <section className="border-b border-foggyGray">
      <p className="mt-4 px-6 text-displayRed">
        For security purposes, please verify your date of birth and the last four digits of your social security number.
      </p>
      <section className="pt-8 lg:px-26 ">
        <UserInfo
          register={register}
          errors={errors}
          setValue={setValue}
          disableDob={disableDob}
          disableSsn={disableSsn}
        />
      </section>
      <h2 className="px-6 pt-7 text-lg font-bold leading-6 lg:pt-6">
        {mapLocaleToMeaningfulFormat().termAndConditionTitle}
      </h2>
      <section className="flex items-start space-x-2 px-6 pt-4">
        <Controller
          name="acceptTerms"
          control={control}
          defaultValue={false}
          render={({ field }) => <Checkbox id="1323" checked={field.value} onCheckedChange={field.onChange} />}
        />
        <label htmlFor="1323" className="px-0.5 text-base font-normal leading-6 text-displayRed">
          <p>{data?.verifyingDemos}</p>
        </label>
      </section>
      <section className="mb-4 flex items-start space-x-2 px-6 ">
        {errors.acceptTerms && <p className="text-scarletRed">{errors.acceptTerms.message}</p>}
      </section>
    </section>
  );
};

export default CreditInformation;
